import type { EmployeeCheckinStatus } from '@/libs/interfaces'

import { MOCK_STORE_ID_1 } from './seed'

/** Simple checked-in/checked-out status fixtures for seed.ts employees at one store. */

export const mockCheckinStatuses: EmployeeCheckinStatus[] = [
  {
    employeeID: 'employee-1',
    employeeCheckin: '2025-06-30T08:00:00Z',
    employeeCheckout: '',
    storeID: MOCK_STORE_ID_1,
    shortUserName: 'AKA',
    status: 'checked-in',
  },
  {
    employeeID: 'employee-2',
    employeeCheckin: '2025-06-30T07:30:00Z',
    employeeCheckout: '2025-06-30T15:30:00Z',
    storeID: MOCK_STORE_ID_1,
    shortUserName: 'JBE',
    status: 'checked-out',
  },
  {
    employeeID: 'employee-3',
    employeeCheckin: '2025-06-30T09:00:00Z',
    employeeCheckout: '',
    storeID: MOCK_STORE_ID_1,
    shortUserName: 'MLI',
    status: 'checked-in',
  },
]
